<template>
  <div class="view__pharmacies--container">
    <h1 class="lvl2-heading">{{ modal.payload.row.name }}</h1>
    <div v-if="modal.payload.row.video">
      <TheVideoPlayer
        :media_url="modal.payload.row.video.media_url"
        :imageUrl="modal.payload.row.video.thumbnail_url"
      />
    </div>
    <h2 class="view__pharmacies--title lvl3-heading">Liste des pharmacies</h2>
    <el-table
      ref="table"
      :data="data"
      style="width: 100%"
      border
      fit
      highlight-current-row
      empty-text="Aucune pharmacie trouvée"
    >
      <el-table-column
        align="center"
        prop="pharmacy"
        label="Pharmacie"
        min-width="140"
        sortable
      ></el-table-column>
      <el-table-column
        align="center"
        prop="support"
        label="Support"
        min-width="100"
        sortable
      ></el-table-column>
      <el-table-column
        align="center"
        prop="answer"
        label="Réponse"
        min-width="80"
        sortable
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui"
import { mapGetters } from "vuex"
import TheVideoPlayer from "@/components/TheVideoPlayer"
import { getCampaignResponses } from "@/api/campaigns"
export default {
  components: {
    ElTable: Table,
    ElTableColumn: TableColumn,
    TheVideoPlayer
  },
  computed: {
    ...mapGetters(["modal"])
  },
  data: () => ({
    data: []
  }),
  created() {
    this.getResponses()
  },
  methods: {
    async getResponses() {
      let { data } = await getCampaignResponses(this.modal.payload.row.id)
      this.data = data.map(({ pharmacist, support, answer }) => ({
        pharmacy: pharmacist.company,
        support: support.name,
        answer:
          answer === null
            ? "Aucune réponse"
            : answer === 0
            ? "Refusé"
            : "Accepté"
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.view__pharmacies {
  &--container {
    width: 700px;
  }
  &--title {
    margin: 0 0 30px 0;
  }
  &--video {
    margin-top: 2rem;
    &-sub {
      font-weight: 800;
    }
  }
}
</style>
